import moment from 'moment';

import DescendingIcon from '@svgIcons/dashboard/descending.svg';

import { ConnectionDatePicker, StartDateText } from './styles';

import { commDateFormat } from '@/utils/timeUtils';

const DATE_FORMAT = 'YYYY-MM-DD';

export default {
    name: 'DatePicker',
    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    methods: {
        dateFormatter(date) {
            if (!date) return '';

            return commDateFormat(
                date,
                this.$t('CONNECTION.date_format'),
                this.language
            );
        },
    },
    render() {
        const { value: startDate, dateFormatter, placeholder } = this;

        const todayDate = new Date();

        const props = {
            attrs: {
                dateRange: { startDate, endDate: startDate },
                'single-date-picker': 'single',
                'auto-apply': true,
                'max-date': todayDate,
                opens: 'right',
                ranges: false,
            },
            on: {
                update: ({ startDate }) => {
                    const value = moment(startDate).format(DATE_FORMAT);
                    this.$emit('update', value);
                },
            },
        };

        const startDateStr = dateFormatter(startDate);

        return (
            <ConnectionDatePicker {...props}>
                <slot slot="input">
                    <StartDateText color={startDateStr ? '#080a0d' : '#6e767d'}>
                        {startDateStr || placeholder}
                    </StartDateText>
                    <DescendingIcon v-view-box width={12} height={12} />
                </slot>
            </ConnectionDatePicker>
        );
    },
};
